import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { raytownMOConfig } from "./data";

export default function RaytownMOPage() {
  return <CityPageTemplate config={raytownMOConfig} />;
}